import React from 'react'
import { Text } from '../../../'
import { DeacriptionDiv, ContainerDivSku, Sku } from './description.styled.component'
import PropTypes from 'prop-types';

export const DescriptionComponent = ({ subTitle, title, sku}) => {

  return (
    <DeacriptionDiv>
      <ContainerDivSku>
        <Text
          fontSize="18px"
          fontFamily="'Amorim Sans Book', sans-serif"
          textTransform="uppercase"
          letterSpacing="2.4px"
          fontWeight="bold"
          titleWithoutTranslate={true}
          textId={subTitle}
        />
        {sku !== '' && 
          <Sku>
            ref. {` ${sku}`}
          </Sku>
        }
      </ContainerDivSku>
     
      <Text
        fontSize="35px"
        fontFamily="Amorim Sans"
        textTransform="uppercase"
        titleWithoutTranslate={true}
        textId={title}
      />
    </DeacriptionDiv>
  )
};

DescriptionComponent.propTypes = {
  subTitle: PropTypes.string, 
  title: PropTypes.string, 
  sku: PropTypes.string
}

DescriptionComponent.defaultProps = {
  subTitle: '', 
  title: '', 
  sku: ''
}
